<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-primary py-5">
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white bebas-header">Bienvenida</h1>
              <p class="text-lead text-white mt-3">Ingresa utilizando tu cuenta de Facebook o tu email.</p>
              
            </b-col>
          </b-row>
        </div>
      </b-container>
      <!-- <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div> -->
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">

          <!-- Main Login/Signup Card -->
          <b-card v-if="!creatingRecords" no-body class="bg-secondary border-0 mb-0">
            <b-card-header class="bg-transparent pb-5"  >
              <div class="text-muted text-center mt-2 mb-3"><small>Ingresa con sólo un click:</small></div>
              <div class="btn-wrapper text-center">
                <a href="#" class="btn btn-neutral btn-icon" @click="facebookSignIn">
                  <span><i class="fab fa-facebook-square"></i></span>
                  <span class="btn-inner--text">Facebook</span>
                </a>
                <!-- <p v-if="creatingRecords" class="h5 text-muted mt-3">Espera un momento mientras creamos tu cuenta...</p> -->
              </div>
            </b-card-header>
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <small>O utiliza tu email para acceder:</small> 
              </div>

              <!-- Form -->
              <b-form>
                <base-input alternative
                            class="mb-3"
                            name="Email"
                            prepend-icon="ni ni-email-83"
                            placeholder="Email"
                            type="email"
                            v-model="model.email">
                </base-input>

                <base-input alternative
                            class="mb-3"
                            name="Password"
                            prepend-icon="ni ni-lock-circle-open"
                            type="password"
                            placeholder="Contraseña"
                            v-model="model.password">
                </base-input>

                <!-- Feedback -->
                <p class="h5 text-warning">{{ feedback }}</p>

                <!-- Submit Button -->
                <div class="text-center py-2">
                  <b-button variant="primary" @click="login">Ingresar</b-button>
                  <b-button variant="primary" @click="signup">
                    <span>Crear cuenta </span>
                    <!-- <span v-if="creatingRecords"><i class="fas fa-spinner fa-spin"></i></span> -->
                  </b-button> 
                </div>
              </b-form>

              <!-- Privacy Policy Notice -->
              <div class="text-center mt-2">
                <small class="text-muted">Al entrar, estás aceptando nuestra <b-link :to="{ name: 'Privacy' }">Política de Privacidad</b-link>.</small>
              </div>

            </b-card-body>
          </b-card>

          <!-- Creating Records Card -->
          <b-card v-if="creatingRecords" no-body class="bg-secondary border-0 mb-0">
            <b-card-header class="bg-transparent pb-5">
              <div class="d-flex flex-column text-center text-muted py-5">
                <div><i class="fas fa-spinner fa-spin display-1"></i></div>
                <small class="mt-3">Espera un momento mientras creamos tu cuenta...</small>
              </div>           
            </b-card-header>
          </b-card>

          <!-- Forgotten Password -->
          <b-row v-if="!creatingRecords" class="my-2">
            <b-col>
              <a href="#" class="text-light" @click="showModal=true"><small>¿Olvidaste tu contraseña?</small></a>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>

    <!-- Password reset email -->
    <b-modal v-model="showModal" :footer-class="'profile-image-modal-footer'" hide-header centered>
      <!-- Form -->
      <p v-if="!requestAccepted">Ingresa el correo con el que accedes a la página:</p>
      <b-form-input v-if="!requestAccepted" v-model="forgottenEmail" placeholder="Ingresa tu email..." type="email"></b-form-input>

      <!-- Success Message -->
      <p v-if="requestAccepted" class="mt-3">¡Listo! Te enviamos un correo con un link para reestablecer tu contraseña.</p>

      <!-- Footer buttons -->
      <template slot="modal-footer">
        <base-button v-if="!requestAccepted" type="primary" @click="sendPasswordResetEmail" :disabled="requestSubmitted">Continuar <span v-if="requestSubmitted"><i class="fas fa-spinner fa-spin"></i></span></base-button>
        <base-button type="secondary" @click="cancelRequest">Cerrar</base-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/functions'

export default {
  name: 'Login',
  data() {
    return {
      model: {
        email: '',
        password: ''
      },
      forgottenEmail: '',
      requestSubmitted: false,
      requestAccepted: false,
      showModal: false,
      feedback: null,
      creatingRecords: false
    };
  },
  methods: {
    login() {
      if (this.validateInputFields()) {
        firebase.auth().signInWithEmailAndPassword(this.model.email, this.model.password)
        .then((cred) => {
          this.$router.push({ name: 'Home' })
        }).catch(err => {
          this.feedback = err.message
        })
        this.feedback = null
      } else {
        this.feedback = "¡Debes llenar todos los campos"
      }
    },
    facebookSignIn() {      
      const facebookAuth = new firebase.auth.FacebookAuthProvider()
      firebase.auth().signInWithPopup(facebookAuth)
      .then(async (credential) => {
        if (credential.additionalUserInfo.isNewUser) {
          // Call the cloud function to create recrods for this newly authenticated user
          await this.createRecordsAndRedirect()
        } else {
          this.$router.push({ name: 'Home' })
        }
      })
      .catch(err => {
        this.feedback = err.message
      })
    },
    async signup() {

      if (this.validateInputFields()) {
        try {
          
          // Create the user and get its credential
          await firebase.auth().createUserWithEmailAndPassword(this.model.email, this.model.password)

          // Call the cloud function to create records for this newly authenticaded user
          await this.createRecordsAndRedirect()

        } catch (err) {
          this.feedback = err.message
        }
      }


    },
    async createRecordsAndRedirect() {

      // Block the form and inform the user that her records are being created
      this.creatingRecords = true

      // Create the user records
      const createRecords = await firebase.functions().httpsCallable('createUserRecords')
      const result = await createRecords()
      // If the records were created, send the user to the checkout page
      if (result.data.created) {
        this.$router.push({ name: 'Checkout' })
      } else {
        this.creatingRecords = false
        this.feedback = result.data.message
      }    
    },
    async sendPasswordResetEmail() {
      // Bring up modal
      try {
        this.requestSubmitted = true
        await firebase.auth().sendPasswordResetEmail(this.forgottenEmail)
        this.requestAccepted = true
      } catch (err) {
        this.showModal = false
        this.requestSubmitted = false
        this.feedback = err.message
      }
    },
    cancelRequest() {
      this.showModal = false
      this.requestSubmitted = false
      this.requestAccepted = false
    },
    validateInputFields() {
      return true
    }
  }
};
</script>

<style>
.bebas-header {
  font-family: 'Bebas Neue';
  font-size: 2em;
  letter-spacing: 1px;
}
</style>